const whatsappIcon = "/assets/whatsapp_icon.svg";
const instagramIcon = "/assets/Instagram_logo.svg";
const tiktokIcon = "/assets/tiktok_icon.svg";
const advboxIcon = "/assets/advbox.svg";
const pipedriveIcon = "/assets/pipedrive.svg";
const projurisIcon = "/assets/projuris_icon.svg";
const astreaIcon = "/assets/astrea_icon.svg";
const asaasIcon = "/assets/asaas-small-logo.svg";
const controljusIcon = "/assets/controljus_icon.svg";
const googleCalendarIcon = "/assets/google_calendar_icon.svg";
const googleMailIcon = "/assets/gmail_icon.svg";
const googleDriveIcon = "/assets/google_drive_icon.svg";
const googleMeetIcon = "/assets/google_meet_icon.svg";
const dropboxIcon = "/assets/dropbox_icon.svg";
const googleSheetsIcon = "/assets/google_drive_icon.svg";
const claudeIcon = "/assets/claude-logo.svg";
const trelloIcon = "/assets/trello-logo-icon.svg";
const zapsignIcon = "/assets/zapsign_logo_icon.svg";
const fazIcon = "/assets/faz-azul.png";
const superlogicaIcon = "/assets/superlogica_icon.svg";
/** O app do cliente. Mesmo ícone que vai para as lojas, vindo do repositório touch-connect. */
const processoJaIcon = "/assets/processo-ja.svg";

export const INTEGRATION_ICONS = {
  whatsappIcon,
  instagramIcon,
  tiktokIcon,
  advboxIcon,
  pipedriveIcon,
  projurisIcon,
  astreaIcon,
  asaasIcon,
  controljusIcon,
  googleCalendarIcon,
  googleMailIcon,
  googleDriveIcon,
  googleMeetIcon,
  dropboxIcon,
  googleSheetsIcon,
  claudeIcon,
  trelloIcon,
  zapsignIcon,
  fazIcon,
  superlogicaIcon,
  processoJaIcon,
};

export const PROVIDER_CONFIG = {
  whatsapp_official: {
    icon: whatsappIcon,
    name: "WhatsApp Oficial",
    category: "channels",
    color: "green",
  },
  whatsapp: {
    icon: whatsappIcon,
    name: "WhatsApp",
    category: "channels",
    color: "green",
  },
  instagram: {
    icon: instagramIcon,
    name: "Instagram",
    category: "channels",
    color: "pink",
  },
  tiktok: {
    icon: tiktokIcon,
    name: "TikTok",
    category: "channels",
    color: "gray",
  },
  advbox: {
    icon: advboxIcon,
    name: "AdvBox",
    category: "third-party",
    color: "blue",
  },
  pipedrive: {
    icon: pipedriveIcon,
    name: "Pipedrive",
    category: "third-party",
    color: "emerald",
  },
  projuris: {
    icon: projurisIcon,
    name: "Projuris",
    category: "third-party",
    color: "blue",
  },
  astrea: {
    icon: astreaIcon,
    name: "Astrea",
    category: "third-party",
    color: "blue",
  },
  asaas: {
    icon: asaasIcon,
    name: "Asaas",
    category: "third-party",
    color: "teal",
  },
  controljus: {
    icon: controljusIcon,
    name: "ControlJUS",
    category: "third-party",
    color: "gray",
  },
  faz: {
    icon: fazIcon,
    name: "SEDEP FAZ",
    category: "third-party",
    color: "blue",
  },
  superlogica: {
    icon: superlogicaIcon,
    name: "Superlógica",
    category: "third-party",
    color: "blue",
  },
  anthropic: {
    icon: claudeIcon,
    name: "Claude (Anthropic)",
    category: "ai",
    color: "violet",
  },
  trello: {
    icon: trelloIcon,
    name: "Trello",
    category: "third-party",
    color: "blue",
  },
  zapsign: {
    icon: zapsignIcon,
    name: "ZapSign",
    category: "third-party",
    color: "yellow",
  },
  "google-calendar": {
    icon: googleCalendarIcon,
    name: "Google Calendar",
    category: "google",
    color: "blue",
  },
  "google-mail": {
    icon: googleMailIcon,
    name: "Google Mail",
    category: "google",
    color: "red",
  },
  "google-drive": {
    icon: googleDriveIcon,
    name: "Google Drive",
    category: "google",
    color: "yellow",
  },
  "google-sheets": {
    icon: googleSheetsIcon,
    name: "Google Sheets",
    category: "google",
    color: "green",
  },
  calendar: {
    icon: googleCalendarIcon,
    name: "Google Calendar",
    category: "google",
    color: "blue",
  },
  mail: {
    icon: googleMailIcon,
    name: "Google Mail",
    category: "google",
    color: "red",
  },
  drive: {
    icon: googleDriveIcon,
    name: "Google Drive",
    category: "google",
    color: "yellow",
  },
  sheets: {
    icon: googleSheetsIcon,
    name: "Google Sheets",
    category: "google",
    color: "green",
  },
  meet: {
    icon: googleMeetIcon,
    name: "Google Meet",
    category: "google",
    color: "teal",
  },
  "google-meet": {
    icon: googleMeetIcon,
    name: "Google Meet",
    category: "google",
    color: "teal",
  },
};

const PROVIDER_ALIASES = {
  WHATSAPP: "whatsapp_official",
  whatsapp: "whatsapp_official",
  INSTAGRAM: "instagram",
  TIKTOK: "tiktok",
  EMAIL: "google-mail",
  TELEGRAM: "telegram",
  WEBCHAT: "webchat",
};

export const normalizeProviderKey = (provider) => {
  if (!provider) return provider;
  return PROVIDER_ALIASES[provider] || provider;
};

export const getProviderConfig = (provider) => (
  PROVIDER_CONFIG[normalizeProviderKey(provider)] || {
    icon: null,
    name: provider,
    category: "other",
    color: "gray",
  }
);
